import axios, { AxiosResponse } from 'axios';

import { ETypTransakce } from 'enums/specialniSluzby/typTransakce';

import { ueSeznamPolozek } from './ueOvereniuctu';

export interface IZaevidovaniGet {
    polozky: ueSeznamPolozek[];
    pocetcp: number;
    pocetuctu: number;
    offset: number;
    limit: number;
    count: number;
    order: string;
}

export interface IDataZaevidovaniGet {
    id?: number;
    idpolozky?: number | string;
    ucet?: string;
    idnabyvatele?: string;
    koducastnika?: string;
    zdrojdat?: string;
    zpusobporizeni?: string;
    zpusobpor?: string;
    idvcdcp?: string;
    typtransakce?: ETypTransakce;
    stav?: string;
    evidovat?: boolean;
    offset?: number;
    limit?: number;
    order?: string;
}

interface IDataZaevidovaniPost {
    id?: number | string;
    idpolozky?: number | string;
    ucet?: string;
    idnabyvatele?: string;
    koducastnika?: string;
    zdrojdat?: string;
    zpusobporizeni?: string;
    idvcdcp?: string;
    typtransakce?: ETypTransakce;
    stav?: string;
}

/* Vrátí seznam položek pro zaevidování v cdcp */
export const ueZaevidovaniGet = (id: number, data: IDataZaevidovaniGet) => {
    return axios({
        method: 'GET',
        url: `/UE/${id}/zaevidovani`,
        params: {
            ...data
        }
    }).then((resp: AxiosResponse<IZaevidovaniGet>) => resp.data);
};

/* Zaeviduje položky požadavku v cdcp */
export const ueZaevidovaniPost = (id: number, data: IDataZaevidovaniPost) => {
    return axios({
        method: 'POST',
        url: `/UE/${id}/zaevidovani`,
        params: {
            ...data
        }
    }).then((resp: AxiosResponse) => resp.data);
};

export enum EKontrolaPocet {
    OK = 'OK',
    PREKROCENO = 'PREKROCENO',
    DUPLICITA = 'DUPLICITA',
    ODMITNUTO = 'ODMITNUTO',
    TIMEOUT = 'TIMEOUT'
}

export interface IZaevidovaniGetDLT {
    polozky: {
        idpolozky: number | string;
        pocetcp: number;
        ucet: string;
        cislozastavnismlouvy: string;
        poznamka: string;
        zpusobpor: string;
        zpusobporizeni: string;
        upozorneni: string;
        stav: string;
        meznidatumprozruseni: string;
        lzeevidovatod: string;
        uzivatel: string;
        sankce: true;
    }[];
    count: number;
    order: string;
    limit: number;
    offset: number;
    pocetcp: number;
    pocetuctu: number;
    kontrolapocet: EKontrolaPocet;
}
export interface IDataZaevidovaniGetDLT {
    id?: number | string;
    idpolozky?: number | string;
    ucet?: string;
    idnabyvatele?: string;
    koducastnika?: string;
    zpusobpor?: string;
    zpusobporizeni?: string;
    idvcdcp?: string;
    typtransakce?: ETypTransakce;
    stav?: string;
    evidovat: boolean;
    offset?: number;
    limit?: number;
    order?: string;
}

interface IDataZaevidovaniPostDLT {
    id?: number | string;
    idpolozky?: number | string;
    ucet?: string;
    zpusobpor?: string;
    sankce?: boolean;
    pocetcp?: string;
    rliv?: ETypTransakce;
    stav?: string;
}

/* Vrátí seznam položek pro zaevidování v cdcp */
export const ueZaevidovaniGetDLT = (id: number, data: IDataZaevidovaniGetDLT) => {
    return axios({
        method: 'GET',
        url: `/UED/${id}/zaevidovani`,
        params: {
            ...data
        }
    }).then((resp: AxiosResponse<IZaevidovaniGetDLT>) => resp.data);
};

/* Zaeviduje položky požadavku v cdcp */
export const ueZaevidovaniPostDLT = (id: number, data: IDataZaevidovaniPostDLT) => {
    return axios({
        method: 'POST',
        url: `/UED/${id}/zaevidovani`,
        params: {
            ...data
        }
    }).then((resp: AxiosResponse) => resp.data);
};
